export const NUM_DASHBOARD = 5;
